import { Person } from "@common/ADAPT.Common.Model/person/person";
import { IDxGridHeaderItem } from "@common/ux/dx.types";
import { ICulturalLeadershipPersonalAnalysisData } from "app/features/culture/cultural-leadership/cultural-leadership-personal-analysis-data.interface";

export class CulturalDataUtilities {
    public static getCulturalLeaderGridHeaderItems(data: ICulturalLeadershipPersonalAnalysisData[]) {
        const culturalLeaders = data.reduce(this.reduceArrayToCulturalLeaders, []);

        const culturalLeadersHeaderItems: IDxGridHeaderItem[] = culturalLeaders.map((culturalLeader) => ({
            text: culturalLeader.fullName,
            value: [this.calculateCulturalLeadersCellValue, "contains", culturalLeader.fullName],
        }));

        culturalLeadersHeaderItems.unshift({
            text: "None allocated",
            value: [this.calculateCulturalLeadersCellValue, "=", ""],
        });

        return culturalLeadersHeaderItems;
    }

    private static calculateCulturalLeadersCellValue(data: ICulturalLeadershipPersonalAnalysisData) {
        if (data.culturalLeader) {
            return data.culturalLeader.fullName;
        }

        return undefined;
    }

    private static reduceArrayToCulturalLeaders(result: Person[], currentValue: ICulturalLeadershipPersonalAnalysisData) {
        if (!currentValue.person) {
            return result;
        }

        for (const relationship of currentValue.person.culturalLeaderRelationships) {
            if (!result.includes(relationship.culturalLeader)) {
                result.push(relationship.culturalLeader);
            }
        }

        return result;
    }
}
